// extracted by mini-css-extract-plugin
export default {"header":"ProjectedBalanceFormHeader_header__YEXMB"};